export async function setCookie(
    cookieName: string,
    value: boolean,
    expirationHours: number
) {
    const date = new Date();
    date.setTime(date.getTime() + expirationHours * 60 * 60 * 1000);
    document.cookie = `${cookieName}=${
        value ? "1" : "0"
    }; expires=${date.toUTCString()}; domain=${
        process.env.REACT_APP_AUTH_COOKIE_STORAGE_DOMAIN
    }`;
    
}
